module.exports = __webpack_public_path__ + "img/orange_star.934bc325.png";